import React, { useContext, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Arrow90degLeft } from 'react-bootstrap-icons';
import { OrderUndoContext } from '../../contexts/OrderUndoContext';
import { TradingContext } from '../../contexts/TradingContext';
import { useUpdateOrder } from '../../hooks/useTradeStation';
import { colors } from '../../theme/colors';

const UndoButton = ({ compact = false }) => {
  const { canUndo, popOrderChange } = useContext(OrderUndoContext);
  const { isPaperTrading } = useContext(TradingContext);
  const { updateOrder } = useUpdateOrder();
  const [isUndoing, setIsUndoing] = useState(false);

  const handleUndo = async () => {
    if (!canUndo || isUndoing) return;

    setIsUndoing(true);
    try {
      // Pop the most recent change from the stack
      const change = popOrderChange();
      
      if (!change) {
        setIsUndoing(false);
        return;
      }

      // Prepare the revert payload based on order type
      let revertPayload = {};
      
      if (change.orderType === 'limit' || change.orderType === 'takeProfit') {
        revertPayload = { LimitPrice: change.oldPrice.toFixed(2) };
      } else if (change.orderType === 'stopLoss') {
        revertPayload = { StopPrice: change.oldPrice.toFixed(2) };
      }

      // Update the order back to its old price
      await updateOrder(isPaperTrading, change.orderId, revertPayload, change.accountId);
      
    } catch (error) {
      console.error('Failed to undo order change:', error);
    } finally {
      setIsUndoing(false);
    }
  };

  if (!canUndo) {
    return null; // Don't show button if nothing to undo
  }

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip>Undo last order change</Tooltip>}
    >
      <button
        onClick={handleUndo}
        disabled={isUndoing}
        className="btn btn-sm"
        style={{
          backgroundColor: 'transparent',
          border: `1px solid ${colors.border}`,
          color: colors.primary,
          padding: compact ? '5px 8px' : '6px 8px',
          height: compact ? 32 : 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4px',
          fontSize: compact ? '0.8125rem' : '0.875rem',
          fontWeight: '500',
          boxShadow: 'none',
          opacity: isUndoing ? 0.6 : 1,
          transition: 'all 0.2s ease',
          cursor: isUndoing ? 'not-allowed' : 'pointer',
          borderRadius: '6px'
        }}
        onMouseEnter={(e) => {
          if (!isUndoing) {
            e.currentTarget.style.backgroundColor = `${colors.primary}20`;
            e.currentTarget.style.borderColor = colors.primary;
            e.currentTarget.style.color = colors.primary;
          }
        }}
        onMouseLeave={(e) => {
          if (!isUndoing) {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.borderColor = colors.border;
            e.currentTarget.style.color = colors.primary;
          }
        }}
      >
        <Arrow90degLeft size={compact ? 15 : 16} />
      </button>
    </OverlayTrigger>
  );
};

export default UndoButton;

